import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useEsri } from '../../esriHooks'

import { getMap, getLegendLayer } from '../selectors'

import { setLegendLayer } from '../actions'

export const useLegendLayerInfo = (mapId, layerId) => {
  const layer = useSelector(getLegendLayer(mapId))
  const layerInfo = layer && layer.findSublayerById(layerId)
  return layerInfo
}

export const useLegendLayerOnly = (mapId) => {
  const layer = useSelector(getLegendLayer(mapId))
  return layer
}

export const useLegendLayer = (mapId, url, sublayers) => {
  const dispatch = useDispatch()
  const [ready, { MapImageLayer }] = useEsri(['esri/layers/MapImageLayer'])
  const map = useSelector(getMap(mapId))

  useEffect(() => {
    if (ready && map) {
      const layer = new MapImageLayer({
        url: url
      })
      map.add(layer)

      layer.watch("loaded", () => {
        if (sublayers) {
          for (var sublayer of layer.sublayers) {
            let popupTemplate = null
            for (var subLayerTemplate of sublayers) {
              if (subLayerTemplate.id === sublayer.id) {
                popupTemplate = subLayerTemplate.popupTemplate
                break;
              }
            }
            if (popupTemplate) {
              sublayer.popupTemplate = popupTemplate
            }
          }
        }
        dispatch(setLegendLayer(mapId, layer))
      })
    }
  }, [ready, map, mapId, url, sublayers])
}